// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box {
  border-radius: 15px;
  padding: 1rem;
  margin: 15px;
  background-color: white;
  box-shadow: 0 0px 5px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.stringBox {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding-left: 1%;
  padding-right: 1%;
  margin-bottom: 10px;
}

p {
  margin: 0;
}

.chart-container {
  height: 60px;
  width: 60px;
}

.success {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

ion-item {
  margin-top: 7px;
}

.objective {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 5px;
  border-radius: 7px;
  background-color: rgb(243, 243, 243);
  margin-bottom: 1em;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/client/objective-client/objective-client.component.scss"],"names":[],"mappings":"AAEA;EACI,mBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,iFAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,SAAA;AADJ;;AAIA;EACI,YAAA;EACA,WAAA;AADJ;;AAIA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;AADJ","sourcesContent":["\r\n\r\n.box {\r\n    border-radius: 15px;\r\n    padding: 1rem;\r\n    margin: 15px;\r\n    background-color: white;\r\n    box-shadow: 0 0px 5px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.stringBox {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    text-align: center;\r\n    padding-left: 1%;\r\n    padding-right: 1%;\r\n    margin-bottom: 10px;\r\n}\r\n\r\np {\r\n    margin: 0;\r\n}\r\n\r\n.chart-container {\r\n    height: 60px;\r\n    width: 60px;\r\n    \r\n}\r\n.success{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n}\r\n\r\nion-item {\r\n    margin-top: 7px;\r\n}\r\n\r\n.objective {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    width: 100%;\r\n    padding: 5px;\r\n    border-radius: 7px;\r\n    background-color: rgb(243, 243, 243);\r\n    margin-bottom: 1em\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
